import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { label: 'トップ', href: '#top' },
    { label: 'サービス内容・料金', href: '#services' },
    { label: '使用する機材・洗剤', href: '#equipment' },
    { label: '選ばれる理由', href: '#reasons' },
    { label: '対応エリア', href: '#area' },
    { label: '自己紹介', href: '#profile' },
    { label: 'よくある質問', href: '#faq' },
    { label: 'お問い合わせ', href: '#contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMenuClick = (href: string) => {
    setIsMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      const headerHeight = 64;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - headerHeight,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                handleMenuClick('#top');
              }}
              className="cursor-pointer flex items-center gap-2"
            >
              <img
                src="https://static.readdy.ai/image/6095022e0c468d9535f3b012298ccfc9/ef758113f5eb1527424f84f893360d0d.jpeg"
                alt="エアクリーンサービス江田島"
                className="h-8 w-auto"
              />
              <span className={`text-xs font-medium whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}>
                エアクリーンサービス
              </span>
            </a>

            {/* Desktop Menu */}
            <nav className="hidden lg:flex items-center gap-6">
              {menuItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleMenuClick(item.href);
                  }}
                  className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                    isScrolled
                      ? 'text-gray-700 hover:text-cyan-600'
                      : 'text-white hover:text-cyan-200'
                  }`}
                >
                  {item.label}
                </a>
              ))}
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors duration-200 cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/20'
              }`}
              aria-label="メニューを開く"
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity duration-300 ${
          isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
        onClick={() => setIsMenuOpen(false)}
      />

      {/* Mobile Menu Panel */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-white z-50 lg:hidden transform transition-transform duration-300 shadow-xl ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="p-4 border-b border-gray-100">
          <div className="flex items-center justify-between">
            <span className="text-lg font-bold text-gray-900">メニュー</span>
            <button
              onClick={() => setIsMenuOpen(false)}
              className="w-10 h-10 flex items-center justify-center text-gray-600 hover:bg-gray-100 rounded-lg cursor-pointer"
              aria-label="メニューを閉じる"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>
        </div>

        <nav className="py-4">
          {menuItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                handleMenuClick(item.href);
              }}
              className="flex items-center gap-3 px-6 py-4 text-gray-700 hover:bg-cyan-50 hover:text-cyan-600 transition-colors duration-200 cursor-pointer border-b border-gray-50"
            >
              <span className="text-base font-medium">{item.label}</span>
            </a>
          ))}
        </nav>

        {/* Contact CTA in Mobile Menu */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-100 bg-gray-50">
          <a
            href="https://lin.ee/ltlhjZa"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 w-full bg-[#06C755] hover:bg-[#05b34c] text-white font-bold py-3 px-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-line-fill text-xl"></i>
            <span>LINEで予約・相談</span>
          </a>
        </div>
      </div>
    </>
  );
}
